import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {BaseFilterComponent} from '@shared/components/filter/base-filter.component';
import {MatSelect} from '@angular/material/select';

@Component({
  selector: 'app-dropdown-filter',
  templateUrl: './dropdown-filter.component.html',
  styleUrls: ['./dropdown-filter.component.scss']
})
export class DropdownFilterComponent extends BaseFilterComponent implements OnInit, AfterViewInit {

  @ViewChild(MatSelect) selectionElement;

  public get active(): boolean {
    return this.filter.selectedOptionValue != null;
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngAfterViewInit(): void {
    this.selectionElement.openedChange.subscribe(isOpen => {
      if (isOpen) {
        this.handleClickOutsideSelectionList();
      }
    })
  }

  /**
   * the margin-top of the overlay overlaps the selection-trigger,
   * thus a click on the trigger while the dropdown is open does not work (e.g. does not close the dropdown)
   * --> handle this manually
   */
  private handleClickOutsideSelectionList() {
    this.selectionElement.panel.nativeElement.parentElement.addEventListener('click', (event) => {
      if (event.target === this.selectionElement.panel?.nativeElement.parentElement) {
        this.selectionElement.close();
      }
    });
  }

  async handleClick(event: Event): Promise<void> {
    if (!this.filter.options && this.filter.optionFactory && !this.filter.loadingOptions) {
      this.selectionElement.close();
      await this.filter.resolveOptions();
      this.changeDetector.detectChanges(); // to ensure correct positioning of overlay panel
      this.selectionElement.open();
    }
  }

  async onSelectionChange(event) {
    await super.onSelectionChange(event);
    this.selectionChange.emit(event);
  }
}
